import { View } from "./ScheduleSettings.view";

export const Container = () => {
  return <View />;
};
